import { currencySymbol } from './offerShared'

/**
 * El símbolo de la moneda delante de un importe («$ 199 USD»): el código de
 * detrás dice CUÁL es, el símbolo hace que se lea como dinero. Nada si la
 * moneda no tiene símbolo propio, porque entonces el código ya basta.
 */
export function CurrencySymbol({ currency, className = 'dash-ofw-amount-symbol' }: { currency: string; className?: string }) {
  const symbol = currencySymbol(currency)
  return symbol ? <span className={className} aria-hidden="true">{symbol}</span> : null
}
